<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        Edit Policy
      </span>
    </div>
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center pt-35-px">
      <Spinner />
    </div>
    <PolicyForm :policy="policy" @submit="onSubmit($event)" />
  </div>
</template>

<script>
  import PolicyService from '../services/policy.service';
  import PolicyForm from './PolicyForm';
  import { filterNewRules, mergeRulesWithSeverity } from '@shared/utils/policyRules';
  import { consumePolicyPrefillFromRoute } from '@shared/utils/policyPrefill';

  export default {
    name: 'PolicyEdit',
    components: {
      PolicyForm
    },
    data() {
      return {
        policyId: this.$route.params.policy,
        policy: {},
        isLoading: true
      };
    },
    mounted() {
      this.getPolicy();
    },
    methods: {
      onSubmit(event) {
        PolicyService.update(this.policyId, event).then(() => {
          this.$router.push('/policy/list');
          this.$showSuccessMessage('Updated Policy');
        });
      },
      async getPolicy() {
        const prefill = consumePolicyPrefillFromRoute(
          this.$router,
          this.$route,
          (payload) =>
            payload &&
            payload.mode === 'edit' &&
            String(payload.policyId) === String(this.policyId)
        );

        try {
          const data = await PolicyService.get(this.policyId);

          const nlp_config_raw = data.nlp_engine_configurations;
          nlp_config_raw.forEach(conf=>{
            const model = {
                model_name: conf.modelName,
                defaced_threshold: conf.defaceThreshold,
                words_ignored: conf.wordsIgnored === '[]' ? []:JSON.parse(conf.wordsIgnored),
                enabled: !!conf.enabled
              };
            if (conf.modelName === 'distilbert'){
              data.distilbert_model = model;
            } else if (conf.modelName === 'xgboost'){
              data.xgboost_model = model;
            }
          });
          
          const notfication_config_raw = data.nlp_notification_configurations;
          if (notfication_config_raw){
            let notifyWhen = 'DistilBERT+'
            switch(notfication_config_raw.notifyWhen){
              case 0:
                notifyWhen = 'Either';
                break;
              case 1:
                notifyWhen = 'Both';
                break;
              case 2:
                notifyWhen = 'DistilBERT+';
                break;
              case 3:
                notifyWhen = 'XGBoost+';
                break;
              default:
                notifyWhen = 'DistilBERT+';
                break;
            }
            data.notifyWhen = notifyWhen;
            data.nlp_enabled = !!notfication_config_raw.enabled;
          } else {
            data.notifyWhen = 'DistilBERT+';
            data.nlp_enabled = false;
          }

          this.policy = data;
          this.policy.url_ids = data.urls.map((url) => url.id.toString());

          if (prefill) {
            // Merge suggested rules and URLs into the fetched policy before rendering the form.
            const existingRules = Array.isArray(this.policy.rules) ? this.policy.rules : [];
            const incomingRules = Array.isArray(prefill.rules) ? prefill.rules : [];
            const newRules = filterNewRules(incomingRules, existingRules);

            if (newRules.length > 0) {
              this.policy.rules = mergeRulesWithSeverity(existingRules, newRules);
            }

            if (Array.isArray(prefill.url_ids) && prefill.url_ids.length > 0) {
              const existingUrlIds = new Set(this.policy.url_ids || []);
              prefill.url_ids.forEach(id => {
                const idStr = String(id);
                if (!existingUrlIds.has(idStr)) {
                  this.policy.url_ids.push(idStr);
                }
              });
            }
          }
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      }
    }
  };
</script>
